export const logUserTrack = (eventType: string, eventIdentifier: string, eventData: any) => {
  const payload: any = {
    eventType: eventType,
    eventIdentifier: eventIdentifier,
    eventData: eventData || null,
  };

  // stringify eventData if needed
  if (typeof eventData === 'object') {
    payload.eventData = JSON.stringify(eventData);
  }

  fetch('/api/sales/track', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
};
